import loadable from "@loadable/component";
import { Carousel } from "@tvg/fuse-design/carousel";
import { SpacingWrapper } from "@tvg/fuse-design/spacing-wrapper";
import useGlobalConfig from "client/context/GlobalConfig";
import React from "react";
import { AmpBrandCardCarousel } from "types/amplience";

export interface BrandCardCarouseProps {
  config: AmpBrandCardCarousel;
}

const BrandCard = loadable(() => import(/* webpackChunkName: "BrandCard" */ "./BrandCard"), {
  resolveComponent: (m) => m.BrandCard,
});

export const BrandCardCarousel: React.FC<BrandCardCarouseProps> = ({ config }) => {
  const { brand } = useGlobalConfig();

  if (!config.slides || !config.slides.length) return null;

  return (
    <SpacingWrapper marginBottom="l">
      <Carousel
        dataTestId="content-brand-card-carousel"
        touchPeek
        title={config.heading}
        lCardsPerPage={5}
        mCardsPerPage={4}
        xxsCardsPerPage={2}
        componentId="content-brand-card-carousel"
      >
        {config.slides?.map((slide, idx) => (
          <BrandCard key={slide._meta.deliveryId} slide={slide} brand={brand} lazyLoad highPriority={idx === 0} />
        ))}
      </Carousel>
    </SpacingWrapper>
  );
};
